import { AdMob, AdOptions, RewardAdOptions, RewardAdPluginEvents, AdMobRewardItem, AdLoadInfo, InterstitialAdPluginEvents, BannerAdOptions, BannerAdSize, BannerAdPosition, BannerAdPluginEvents, AdMobBannerSize } from '@capacitor-community/admob';
import { Capacitor } from '@capacitor/core';


function getBannerID(): string {
    if (Capacitor.getPlatform() == "ios"){
        return "ca-app-pub-9390519061536184/7928242937"
    }

    if (Capacitor.getPlatform() == "android"){
        return "ca-app-pub-9390519061536184/5100190610"
    }

    console.warn("Returning test banner id")
    return "ca-app-pub-3940256099942544/6300978111"
}

function getInterstitialID(): string {
    if (Capacitor.getPlatform() == "ios"){
        return "ca-app-pub-9390519061536184/8761182147"
    }

    if (Capacitor.getPlatform() == "android"){
        return "ca-app-pub-9390519061536184/1100116290"
    }

    console.warn("Returning test interstiatial id")
    return "ca-app-pub-3940256099942544/1033173712";
}

function getRewardedVideoID(): string {
    if(Capacitor.getPlatform() == "ios"){
        return "ca-app-pub-9390519061536184/7590451145"
    }

    if (Capacitor.getPlatform() == "android"){
        return "ca-app-pub-9390519061536184/1100116290"
    }

    console.warn("Returning test rewarded id")
    return "ca-app-pub-3940256099942544/5224354917";
}


export async function initializeAdmob(): Promise<void> {
    const { status } = await AdMob.trackingAuthorizationStatus();

    if (status === 'notDetermined') {
        /**
         * If you want to explain TrackingAuthorization before showing the iOS dialog,
         * you can show the modal here.
         * ex)
         * const modal = await this.modalCtrl.create({
         *   component: RequestTrackingPage,
         * });
         * await modal.present();
         * await modal.onDidDismiss();  // Wait for close modal
         **/
    }

    AdMob.initialize({
        requestTrackingAuthorization: true,
        testingDevices: [''],
        initializeForTesting: false,
    });
}

export function showBannerMessage() {
    window.parent.postMessage("showBanner", "*");
}

export function closeBannerMessage() {
    window.parent.postMessage("closeBanner", "*");
}

export function showInterstitialMessage() { 
    window.parent.postMessage("showInterstitial", "*");
}

export function showRewardedVideoMessage() {
    window.parent.postMessage("showRewardedVideo", "*");
}


export async function showBanner(): Promise<void> {
    console.log("Working on loading banner")
    AdMob.addListener(BannerAdPluginEvents.Loaded, () => {
        // Subscribe Banner Event Listener
        console.log("Banner successfully loaded");
    });

    AdMob.addListener(BannerAdPluginEvents.SizeChanged, (size: AdMobBannerSize) => {
        // Subscribe Change Banner Size
    });

    const options: BannerAdOptions = {
        adId: getBannerID(),
        adSize: BannerAdSize.BANNER,
        position: BannerAdPosition.BOTTOM_CENTER,
        margin: 0,
        // isTesting: true
        // npa: true
    };
    console.log("Working on loading banner 2")
    AdMob.showBanner(options);
}


export async function closeBanner(): Promise<void> {
    console.log("Trying to close Banner")
    AdMob.hideBanner()
}

export async function showInterstitial(): Promise<void> {
    AdMob.addListener(InterstitialAdPluginEvents.Loaded, (info: AdLoadInfo) => {
        // Subscribe prepared interstitial
    });

    const options: AdOptions = {
        adId: getInterstitialID(),
        // isTesting: true
        // npa: true
    };
    await AdMob.prepareInterstitial(options);
    await AdMob.showInterstitial();
}

export async function showRewardedVideo(): Promise<void> {
    AdMob.addListener(RewardAdPluginEvents.Loaded, (info: AdLoadInfo) => {
        // Subscribe prepared rewardVideo
    });

    AdMob.addListener(RewardAdPluginEvents.Rewarded, (rewardItem: AdMobRewardItem) => {
        // Subscribe user rewarded
        console.log(rewardItem);
    });

    const options: RewardAdOptions = {
        adId: getRewardedVideoID(),
        // isTesting: true
        // npa: true
        // ssv: {
        //   userId: "A user ID to send to your SSV"
        //   customData: JSON.stringify({ ...MyCustomData })
        //}
    };
    await AdMob.prepareRewardVideoAd(options);
    const rewardItem = await AdMob.showRewardVideoAd();
}

// APP ID iOS:  ca-app-pub-9390519061536184~5375351340 
// APP ID Android: ca-app-pub-9390519061536184~2018446296